import { Link } from 'react-router-dom'

export function PrivacyPolicyPage() {
  return (
    <div className="legal-page">
      <div className="legal-page-inner">
        <Link to="/login" className="legal-back-link">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10 12L6 8l4-4" /></svg>
          Back to Sign in
        </Link>

        <div className="legal-header">
          <img src="/images/paver-logo.png" alt="Paver" className="legal-logo" />
          <h1>Privacy Policy</h1>
          <p className="legal-effective">Effective Date: March 17, 2026</p>
        </div>

        <div className="legal-body">
          <p>
            Paver Technologies, Inc. ("Paver," "we," "us," or "our") is committed to protecting the privacy
            of our users. This Privacy Policy explains how we collect, use, disclose, and safeguard your
            information when you use our web application and related services (collectively, the "Service").
          </p>

          <h2>1. Information We Collect</h2>

          <h3>1.1 Account Information</h3>
          <p>
            When you create an account, we collect your name, email address, company name, phone number,
            and role within your organization. If your account is created by a company administrator, they
            provide this information on your behalf.
          </p>

          <h3>1.2 Usage Data</h3>
          <p>
            We automatically collect information about how you interact with the Service, including pages
            visited, features used, estimates created, proposals generated, timestamps of activity, browser
            type, operating system, and IP address. This data helps us improve performance and understand
            how our Service is used.
          </p>

          <h3>1.3 Project and Business Data</h3>
          <p>
            In the course of using the Service, you may input project details, client information, cost
            estimates, proposal content, map data, uploaded images, digital signatures, and other
            business-related information. This data is stored securely and associated with your tenant
            account.
          </p>

          <h3>1.4 Payment Information</h3>
          <p>
            Payment processing is handled by Stripe, Inc. We do not store your credit card numbers or
            bank account details on our servers. Stripe's use of your information is governed by their
            own privacy policy.
          </p>

          <h3>1.5 Communications</h3>
          <p>
            When you contact us for support or use the in-app help chat, we collect the content of those
            communications to provide assistance and improve our Service.
          </p>

          <h2>2. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <p>
            Provide, operate, and maintain the Service; process your estimates, proposals, and related
            workflows; send transactional emails such as proposal delivery, account invitations, and
            password resets; analyze usage patterns to improve features and user experience; enforce our
            Terms and Conditions and prevent misuse; comply with legal obligations; and communicate
            important updates about the Service.
          </p>

          <h2>3. How We Share Your Information</h2>
          <p>
            We do not sell your personal information. We may share your data with the following categories
            of recipients:
          </p>
          <p>
            <strong>Service Providers:</strong> We use third-party services to operate the platform, including
            Supabase (database and file storage), Stripe (payment processing), Resend (transactional email),
            Mapbox (mapping and geocoding), Vercel (hosting), and Anthropic (AI-powered help features).
            These providers access your data only as necessary to perform their services and are bound by
            their own privacy commitments.
          </p>
          <p>
            <strong>Your Organization:</strong> If you use the Service as part of a company account, your
            administrator and other authorized users within your organization may access data you create,
            subject to the role-based access controls configured by your administrator.
          </p>
          <p>
            <strong>Proposal Recipients:</strong> When you send a proposal to a client, the recipient
            will have access to the proposal content, your company's branding, and contact information
            as included in the proposal.
          </p>
          <p>
            <strong>Legal Requirements:</strong> We may disclose your information if required by law,
            regulation, legal process, or governmental request, or to protect the rights, property, or
            safety of Paver, our users, or the public.
          </p>

          <h2>4. Data Retention</h2>
          <p>
            We retain your data for as long as your account is active or as needed to provide the Service.
            If you or your organization's administrator requests account deletion, we will delete or
            anonymize your personal data within 30 days, except where retention is required by law or
            for legitimate business purposes such as resolving disputes.
          </p>

          <h2>5. Data Security</h2>
          <p>
            We implement industry-standard security measures to protect your data, including encryption
            in transit (TLS/SSL), encrypted storage, tenant-level data isolation, role-based access
            controls, and regular security reviews. However, no method of transmission or storage is
            completely secure, and we cannot guarantee absolute security.
          </p>

          <h2>6. Your Rights</h2>
          <p>
            Depending on your jurisdiction, you may have the right to access the personal data we hold
            about you, request correction of inaccurate data, request deletion of your data, object to
            or restrict certain processing, request data portability, and withdraw consent where processing
            is based on consent. To exercise any of these rights, please contact us at
            privacy@getpaver.com.
          </p>

          <h2>7. Cookies and Tracking</h2>
          <p>
            The Service uses essential cookies and local storage to maintain your authentication session
            and application preferences. We do not use third-party advertising cookies or cross-site
            tracking technologies.
          </p>

          <h2>8. Children's Privacy</h2>
          <p>
            The Service is not intended for individuals under the age of 18. We do not knowingly collect
            personal information from children. If we become aware that we have collected data from a
            child, we will take steps to delete it promptly.
          </p>

          <h2>9. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. When we do, we will revise the
            "Effective Date" at the top of this page and, for material changes, notify you via email
            or an in-app notice. Your continued use of the Service after changes are posted constitutes
            acceptance of the updated policy.
          </p>

          <h2>10. Contact Us</h2>
          <p>
            If you have questions or concerns about this Privacy Policy or our data practices, please
            contact us at:
          </p>
          <p>
            Paver Technologies, Inc.<br />
            Email: privacy@getpaver.com<br />
            Website: https://getpaver.com
          </p>
        </div>

        <div className="legal-footer-nav">
          <Link to="/terms">Terms &amp; Conditions</Link>
          <span className="legal-footer-sep">|</span>
          <Link to="/login">Sign in</Link>
        </div>
      </div>
    </div>
  )
}
